import React, { useState } from 'react';
import { IconButton, Popover, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { PRES, TYPE } from '../chrome';
import { COPY } from '../presentationCopy';
import { focusVisibleSx } from '../ui/focus';

interface PageKindInfoProps {
  text: string;
  tone?: 'light' | 'dark';
}

const PageKindInfo: React.FC<PageKindInfoProps> = ({ text, tone = 'dark' }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const onLight = tone === 'light';
  return (
    <>
      <IconButton
        size="small"
        aria-label={COPY.pageKindInfo}
        aria-expanded={Boolean(anchor)}
        aria-haspopup="dialog"
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(event.currentTarget);
        }}
        sx={{
          color: onLight ? PRES.textSecondary : 'rgba(255,255,255,0.88)',
          ...focusVisibleSx,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { role: 'dialog', 'aria-label': COPY.pageKindInfo } }}
      >
        <Typography
          sx={{
            fontFamily: TYPE.ui,
            ...TYPE.body,
            color: PRES.textPrimary,
            maxWidth: 360,
            p: 1.5,
          }}
        >
          {text}
        </Typography>
      </Popover>
    </>
  );
};

export default PageKindInfo;
